import { useEffect, useState, useCallback } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import debounce from "lodash.debounce"
import ErrorAlert from '../../components/common/ErrorAlert'
import Button from '../../components/common/Button'
import Modal from '../../components/modals/Modal'
import ModalConfirmacion from '../../components/modals/ModalConfirmacion'
import DesplegableDinamico from '../../components/modals/DesplegableDinamico'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import ListaExpandible from '../../components/tables/ListaExpandible'

const Secciones = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idSeccion, setIdSeccion] = useState("") // ID de la sección / dentro de registro de accion para una seccion
    const [idAccion, setIdAccion] = useState("") // ID de la acción / dentro de registro de accion para una seccion
    const [seccionDetalleId, setSeccionDetalleId] = useState("") // ID del detalle de la sección / caputrado para la funcion eliminar accion
    const [acciones, setAcciones] = useState([]) // Acciones disponibles/ en registro de accion dentro de una seccion
    const [seccion, setSeccion] = useState("") // Nombre de la sección
    const [buscarSeccion, setBuscarSeccion] = useState("") // Campo para buscar por seccion
    const [accion, setAccion] = useState("") // Acción seleccionada
    const [descripcion, setDescripcion] = useState("") // Descripción de la sección
    // modales
    const [mostrarModal, setMostrarModal] = useState(false) // Modal para registrar nueva seccion
    const [mostrarModalAccion, setMostrarModalAccion] = useState(false) // Modal para registrar nueva acción
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false) // Modal para eliminar una sección
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false) // Modal para eliminar una sección
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false) // Modal de confirmación de eliminación
    // notificaciones y cargas
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [selectedId, setSelectedId] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    // Carga inicial de las secciones
    useEffect(() => { obtenerSecciones() }, [])

    // Función para obtener las secciones
    const obtenerSecciones = async () => {
        const respuesta = await consumirApi('GET', `maestros/seccion/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : [])
        console.log(respuesta.data)
        setCargando(false)
    }

    // Crear la función debounced utilizando useCallback
    const realizarConsultaDebounced = useCallback(
        debounce(async (seccion) => {
            if (seccion.trim() === "") {
                obtenerSecciones()
            } else {
                // Reemplazar el / con un +
                const seccionBusqueda = seccion.trim().replace(/\//g, '+')
                const respuesta = await consumirApi('GET', `maestros/seccion/completo/${idEmpresa}/${seccionBusqueda}`)
                setDatos(respuesta.success ? respuesta.data : respuesta.error)
            }
        }, 300), [] // Solo se crea una vez
    )

    // Consulta de paquetes de acuerdo a lo ingresado a campo busqueda
    const consultarSeccion = async (seccion) => {
        setBuscarSeccion(seccion)
        realizarConsultaDebounced(seccion) // Llamar al debounce
    }

    // Registra una nueva sección
    const registrarSeccion = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/seccion`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Sección registrada correctamente" })
            limpiarCampos()
            obtenerSecciones()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Abre el modal para registrar una nueva acción asociada a una sección
    const abrirModalAccion = (e, idSeccion) => {
        e.stopPropagation() // Detiene la propagación del evento
        setIdSeccion(idSeccion)
        setMostrarModalAccion(true)
    }

    // Crear la función debounced utilizando useCallback
    const realizarConsultaDebouncedAcciones = useCallback(
        debounce(async (accion) => {
            if (accion.trim() === "") {
                setAcciones([])
            } else {
                // Reemplazar el / con un +
                const accionBusqueda = accion.trim().replace(/\//g, '+')
                const url = `maestros/accion/buscar/${idEmpresa}/${accionBusqueda}`
                const respuesta = await consumirApi('GET', url)
                setAcciones(respuesta.success ? respuesta.data : respuesta.error)
            }
        }, 300), [] // Solo se crea una vez
    )

    // Consulta las acciones disponibles según el texto de búsqueda
    const consultarAcciones = async (accion) => {
        realizarConsultaDebouncedAcciones(accion)
    }

    // Maneja la búsqueda de acciones según el texto ingresado / va mostrando resultados segun texto ingresado
    const manejarBusquedaAccion = (accion) => {
        setAccion(accion)
        consultarAcciones(accion)
    }

    // Selecciona una acción del listado de sugerencias y carga el id de la seccion y de la accion selaccionada
    const manejarSeleccionAccion = (data) => {
        setAccion(data.accion)
        setIdAccion(data.id)
    }

    // Agrega una nueva acción a la sección seleccionada
    const registrarAccion = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const respuesta = await consumirApi('POST', `maestros/seccion-detalle`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Acción registrada correctamente" })
            limpiarCampos()
            consultarSeccion(buscarSeccion)
        } else {
            setError(respuesta.error)
        }
    }

    // funcion para abrir el modal para editar ubicacion
    const abrirModalEditarSeccion = (data) => {
        data.e.stopPropagation()
        setIdSeccion(data.id)
        setSeccion(data.titulo)
        setDescripcion(data.descripcion)
        setMostrarModalEditar(true)
    }

    // Edición ubicación
    const enviarEdicionSeccion = async (e) => {
        e.preventDefault()
        const data = { seccion, descripcion }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/seccion/${idSeccion}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Sección actualizada correctamente" })
            limpiarCampos()
            consultarSeccion(buscarSeccion)
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // funcion para abrir el modal para editar accion
    const abrirModalEliminarSeccion = (e, id) => {
        e.stopPropagation() // Detiene la propagación del evento
        setSelectedId((prevSelectedId) => (prevSelectedId === id ? null : id))
        setMostrarModalEliminar(true)
    }
    // funcion para abrir el modal para editar accion
    const eliminarSeccion = async () => {
        setMostrarModalEliminar(true)
        const respuesta = await consumirApi('DELETE', `maestros/seccion/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Paquete eliminado correctamente" })
            limpiarCampos()
            consultarSeccion(buscarSeccion)
        } else {
            setError(respuesta.error)
        }
    }

    // obtiene el id del detalle de la seccion y Abre el modal de confirmación para eliminar una acción
    const abrirModalEliminar = (id) => {
        setSeccionDetalleId(id)
        setMostrarModalConfirmacion(true)
    }

    // Elimina una acción seleccionada
    const eliminarAccion = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/seccion-detalle/${seccionDetalleId}`)
        if (respuesta.success) {
            setNotificacion({
                estado: true, tipo: "eliminar", mensaje: "Acción eliminada correctamente"
            })
            setMostrarModalConfirmacion(false)
            consultarSeccion(buscarSeccion)
        } else {
            setError(respuesta.error)
            setMostrarModalConfirmacion(false)
        }
    }

    // Reinicia los campos de los formularios y los estados relacionados
    const limpiarCampos = () => {
        setSelectedId(null)
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setMostrarModalAccion(false)
        setSeccion('')
        setDescripcion('')
        setError('')
        setAcciones('')
        setAccion('')
        setIdAccion('')
        setIdSeccion('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <div className="flex items-center gap-4 mt-2 bg-white">
                <Button className="ml-4" texto='+ Nueva Sección' onClick={() => setMostrarModal(true)} />
                <Input name="buscar_seccion" value={buscarSeccion} onChange={consultarSeccion} />
            </div>

            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5 mt-2">No se encontraron secciones</div>
                ) : (
                    <div className="max-h-content overflow-y-auto">
                        <ListaExpandible
                            nombre="acciones"
                            campoPrincipal="seccion"
                            campoDetalle="accion"
                            data={datos}
                            registrar={abrirModalAccion}
                            eliminar={abrirModalEliminar}
                            eliminarPadre={abrirModalEliminarSeccion}
                            editarPadre={abrirModalEditarSeccion}
                        />
                    </div>
                )
            )}

            {/* Modal para registrar una nueva sección */}
            <Modal isOpen={mostrarModal} title="Registrar nueva sección" onClose={limpiarCampos}>
                <Form onSubmit={registrarSeccion} isSubmitting={isSubmitting}>
                    <Input name="seccion" value={seccion} label="Nombre de la sección" onChange={setSeccion} />
                    <Input name="descripcion" type="textarea" value={descripcion} label="Descripción" onChange={setDescripcion} />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal para registrar una nueva acción */}
            <Modal isOpen={mostrarModalAccion} title="Registrar nueva acción" onClose={limpiarCampos}>
                <Form onSubmit={registrarAccion}>
                    {/* Input oculto para el ID de la sección */}
                    <Input show="hidden" name="seccion_id" value={idSeccion} onChange={setIdSeccion} />
                    {/* Input oculto para el ID de la acción */}
                    <Input show="hidden" name="accion_id" value={idAccion} onChange={setIdAccion} />
                    {/* Input para el nombre de la acción */}
                    <Input name="accion" value={accion} label="Nombre de la acción" onChange={manejarBusquedaAccion} />
                    <DesplegableDinamico
                        label="Seleccionar Acción"
                        opciones={acciones}
                        campo="accion"
                        onSeleccionar={manejarSeleccionAccion}
                    />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal para editar una  sección */}
            <Modal isOpen={mostrarModalEditar} title="Actualizar sección" onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionSeccion} type='update' isSubmitting={isSubmitting} texto='Actualizar'>
                    <Input name="seccion" value={seccion} label="Nombre de la sección" onChange={setSeccion} />
                    <Input name="descripcion" type="textarea" value={descripcion} label="Descripción" onChange={setDescripcion} />
                    {error && (<ErrorAlert message={error} />)}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un seccion*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarSeccion}
                mensaje="¿Estás seguro de que deseas eliminar la sección?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>


            {/* Modal para confirmar la eliminación de una acción */}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacion}
                onClose={() => setMostrarModalConfirmacion(false)}
                onConfirm={eliminarAccion}
                mensaje="¿Estás seguro de que deseas eliminar esta acción?"
            />
        </div>
    )
}

export default Secciones
